import React from 'react';
import { Camera, MoveHorizontal, ZoomIn, RotateCw, MoveVertical, Activity } from 'lucide-react';
import { CAMERA_PRESETS } from './controlConstants.js';

const ICON_MAP = {
  Camera,
  MoveHorizontal,
  ZoomIn,
  RotateCw,
  MoveVertical,
  Activity
};

export function CameraSelector({ currentPreset, onSelectPreset }) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8' }}>
          Movimiento de Cámara
        </label>
        <span style={{ fontSize: '11px', color: '#c084fc', fontWeight: 600 }}>
          {CAMERA_PRESETS.find(c => c.id === currentPreset)?.label}
        </span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
        {CAMERA_PRESETS.map((cam) => {
          const isSelected = currentPreset === cam.id;
          const IconComp = ICON_MAP[cam.icon] || Camera;
          return (
            <button
              key={cam.id}
              type="button"
              onClick={() => onSelectPreset(cam.id)}
              title={cam.desc}
              style={{
                padding: '10px 6px',
                borderRadius: '8px',
                fontSize: '11px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                background: isSelected ? 'rgba(168, 85, 247, 0.16)' : '#141724',
                color: isSelected ? '#c084fc' : '#94a3b8',
                border: isSelected ? '1px solid rgba(192, 132, 252, 0.6)' : '1px solid rgba(255,255,255,0.06)',
                boxShadow: isSelected ? '0 0 12px rgba(168, 85, 247, 0.25)' : 'none',
                transition: 'all 0.15s ease'
              }}
            >
              <IconComp size={16} color={isSelected ? '#c084fc' : '#64748b'} />
              <span>{cam.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

